import { useState } from "react";
import { Loader2 } from "lucide-react";
import moment from "moment";

import { SearchInput } from "components/ui";

import { SortByButton } from "./SortByButton";
import styles from "./Table.module.css";

export const Table = ({ items, tableName, isLoading }) => {
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState("newest-first");

  const sortedAndFilteredItems =
    items
      ?.sort((a, b) => {
        if (!a.prescribedDate && !b.prescribedDate) return 0;
        if (!a.prescribedDate) return sorting === "newest-first" ? 1 : -1;
        if (!b.prescribedDate) return sorting === "newest-first" ? -1 : 1;

        if (sorting === "newest-first") {
          return (
            moment(b.prescribedDate).valueOf() -
            moment(a.prescribedDate).valueOf()
          );
        }
        return (
          moment(a.prescribedDate).valueOf() -
          moment(b.prescribedDate).valueOf()
        );
      })
      .filter((item) =>
        item.tradeName?.toLowerCase()?.includes(search.toLowerCase())
      ) || [];

  const renderTableContent = () => {
    if (isLoading) {
      return (
        <div className={styles.emptyState}>
          <Loader2 className={styles.loadingSpinner} size={24} />
          <p className={styles.emptyStateTitle}>Loading data...</p>
          <p className={styles.emptyStateText}>
            Please wait while we fetch the medical history.
          </p>
        </div>
      );
    }

    if (sortedAndFilteredItems.length === 0) {
      return (
        <div className={styles.emptyState}>
          <p className={styles.emptyStateTitle}>No items found</p>
          <p className={styles.emptyStateText}>
            {search
              ? "Try adjusting your search or filters to find what you're looking for."
              : "There are no items to display at this time."}
          </p>
        </div>
      );
    }

    return (
      <ul className={styles.tableItems}>
        {sortedAndFilteredItems.map((item) => (
          <li className={styles.tableItem} key={item.id}>
            <p id={`${tableName}-table-drug-name`}>{item.tradeName}</p>
            <p id={`${tableName}-table-dose`}>{item.dosage}</p>
            <p id={`${tableName}-table-type`}>{item.acuteLongTerm}</p>
            <p id={`${tableName}-table-date-prescribed`}>
              {item.prescribedDate
                ? moment(item.prescribedDate).format("DD-MM-YYYY")
                : "N/A"}
            </p>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <div className={styles.tableWarpper}>
        <div className={styles.table}>
          <div className={styles.tableTopBarWrapper}>
            <SearchInput
              value={search}
              onChange={setSearch}
              placeholder="Search"
              disabled={isLoading}
            />
            <SortByButton
              selectedItem={sorting}
              setSelectedItem={setSorting}
              disabled={isLoading}
            />
          </div>
          <div className={styles.tableHeader}>
            <p id={`${tableName}-table-drug-name`}>Drug name</p>
            <p id={`${tableName}-table-dose`}>Dose</p>
            <p id={`${tableName}-table-type`}>Type</p>
            <p id={`${tableName}-table-date-prescribed`}>Start Date</p>
          </div>
          {renderTableContent()}
        </div>
      </div>
    </>
  );
};
